<template>
    <div class="price-table-wrap">
        <Teleport to="#main-view">
            <div class="sort-button-container sort-button-container--fixed">
                <div class="sort-button" style="padding-right: 60px;">{{ $t('price.coin') }}</div>
                <div class="sort-button">{{ $t('price.price') }}</div>
                <div class="sort-button">{{ $t('price.volume') }}</div>
            </div>
        </Teleport>
        <div class="vol-table">
        <div v-for="item in marketData" :key="item.symbol" class="vol-row">
            <!-- <div id="vol-row-id">{{ item.id }}</div> -->
            <div id="vol-row-symbol">
                <img :src="getImagePath(item.symbol)" @error="handleImageError(item.symbol, $event)" alt="">
                <div>
                    <div>{{ formatSymbol(item.symbol) }}</div>
                    <p>Binance</p>
                </div>
            </div>
            <div>${{ formatPrice(item.price) }}</div>
            <div id="vol-row-volume">${{ formatVolume(item.vol) }}</div>
        </div>
        </div>
    </div>
</template>

<script>
// import SortButton from './SortButton.vue';

export default {
    components: {
        // SortButton,
    },
    props: {
        marketType: String,
        marketData: Array,
        sortData: Function,
    },
    methods: {
        sort(sortDetails) {
            this.sortData(sortDetails.property, sortDetails.order);
        },
        getImagePath(symbol) {
            const baseSymbol = symbol.replace('USDT', '').toLowerCase();
            try {
                return require('@/assets/images/coin_logos/' + baseSymbol + '.svg');
            } catch {
                return require('@/assets/images/coin_logos/default.svg');
            }
        },
        handleImageError(symbol, event) {
            const baseSymbol = symbol.replace('USDT', '').toLowerCase();
            event.target.src = require('@/assets/images/coin_logos/' + baseSymbol + '.png');
        },
        formatSymbol(symbol) {
            const separatorIndex = symbol.indexOf("USDT");
            if (separatorIndex !== -1) {
                return symbol.substring(0, separatorIndex) + '/USDT';
            }
            return symbol;
        },
        formatPrice(value) {
            if (value == null) return "NULL";

            // Convert the number to a string
            let stringValue = value.toString();
            let parts = stringValue.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            stringValue = parts.join('.');

            if (stringValue.indexOf('.') !== -1) {
                stringValue = stringValue.replace(/0+$/, '');
                stringValue = stringValue.replace(/\.$/, '');
            }

            return stringValue;
        },
        formatVolume(value) {
            if (value >= 1e9) {
                return (value / 1e9).toFixed(2) + 'B';
            } else if (value >= 1e6) {
                return (value / 1e6).toFixed(2) + 'M';
            } else if (value >= 1e3) {
                return (value / 1e3).toFixed(2) + 'K';
            } else {
                return value.toString();
            }
        },
    },
};
</script>
